'use client';
// 'use client' required: holds the selected date range in local state and
// re-renders the tiles/chart on every filter change.

import { useState } from 'react';
import {
  ClaimsDashboardDateFilter,
  resolveDateRangePreset,
  type ClaimsDashboardDateRange,
} from '@/components/vehicle-claims/dashboard/ClaimsDashboardDateFilter';
import { ClaimsStatusTiles } from '@/components/vehicle-claims/dashboard/ClaimsStatusTiles';
import { ClaimsDashboardChart } from '@/components/vehicle-claims/dashboard/ClaimsDashboardChart';
import type { VehicleClaimListFilters } from '@/types/vehicle-claim';

// Matches ClaimsDashboardDateFilter's own default preset ('all'), so the
// initial render already reflects what its mount-time onChange will emit.
const DEFAULT_RANGE = resolveDateRangePreset('all');

export function ClaimsDashboardContent() {
  const [range, setRange] = useState<ClaimsDashboardDateRange>(DEFAULT_RANGE);

  const filters: VehicleClaimListFilters = {
    intimation_from: range.from ?? undefined,
    intimation_to: range.to ?? undefined,
  };

  return (
    <div className="mx-auto w-full max-w-[1600px] px-4 py-8 sm:px-6 lg:px-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Claims Dashboard</h1>
        <p className="mt-1 text-sm text-gray-500">
          Claim volume and status breakdown for the selected date range.
        </p>
      </div>

      <div className="mb-6">
        <ClaimsDashboardDateFilter onChange={setRange} />
      </div>

      <div className="space-y-6">
        <ClaimsStatusTiles filters={filters} />
        <ClaimsDashboardChart filters={filters} />
      </div>
    </div>
  );
}
